import React from 'react';
import { css } from '@emotion/react';

import type { RibbonMedia } from '../InteractionInfo';
const ReactPlayer = React.lazy(() => import('react-player'));

export const MediaRibbon: React.FC<{
  media?: RibbonMedia[];
  width: number;
  height: number;
}> = ({ media, width, height }) => {
  if (!media || media.length === 0) {
    return null;
  }
  return (
    <div
      css={css`
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 0;
        border-top-right-radius: 1.5rem;
        border-top-left-radius: 1.5rem;
        overflow: hidden;
        overflow-x: scroll;
      `}
    >
      <div
        className='flex '
        css={css`
          height: 100%;
          width: 1000px;
        `}
      >
        {media.map((m) => (
          <>
            {m.videoUrl ? (
              <React.Suspense>
                <div className='flex bg-black'>
                  <ReactPlayer
                    key={m.url}
                    width={`${width}px`}
                    height='100%'
                    url={m.videoUrl!}
                    muted
                    playsinline
                    controls={false}
                  />
                </div>
              </React.Suspense>
            ) : (
              <div>
                <img
                  css={css`
                    margin-right: 0.1rem;
                    height: ${height}px;
                  `}
                  key={m.url}
                  src={m.url}
                />
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};
